import { render, staticRenderFns } from "./IconArrowRight.vue?vue&type=template&id=0a3d2797&"
import script from "./IconArrowRight.vue?vue&type=script&lang=ts&"
export * from "./IconArrowRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports